import React from 'react';
import { gameRequests } from '../../request/requests';

export default function ResponseEditor({response, loadQuestions}){

    const [responseTitle, setResponseTitle] = React.useState(response.title);
    const [is_correct, setIsCorrect] = React.useState(response.is_correct);

    return (
        <li style={{padding: '10px', marginTop: '10px'}}>
            <input type="text" value={responseTitle} onChange={(e)=>{setResponseTitle(e.target.value)}} />
            <button onClick={async()=>{await gameRequests.updateResponse(response.id, responseTitle, is_correct); loadQuestions();}}>
                Modifier
            </button>
            <button style={{color: 'red'}} onClick={async()=>{await gameRequests.deleteResponse(response.id); loadQuestions();}}>
                Supprimer
            </button>
            <input type="checkbox" checked={is_correct} onChange={(e)=>{setIsCorrect(e.target.checked)}}/>
        </li>
    );

}